// ── 状態管理 ──────────────────────────────────────────
let rawData   = [];   // { date, close }
let closeData = [];   // 終値の数値配列
let dataSource = 'yf';
let currentMode = 'lstm';
let chartMain = null, chartLoss = null, chartAe = null, chartError = null, chartCombined = null;

// 両モードの結果を保存（統合ビュー用）
let lstmResult = null;  // { labels, actual, pred, futPad, allLabels }
let aeResult   = null;  // { labels, anomPoints, closeSlice }

// ── CPU バックエンド固定 ──────────────────────────────
(async () => {
  await tf.setBackend('cpu');
  await tf.ready();
  document.getElementById('backendBadge').textContent = 'BACKEND: CPU';
})();

// ── スライダー連動 ────────────────────────────────────
const r = document.getElementById('r_thresh');
const n = document.getElementById('n_thresh');
r.addEventListener('input', () => n.value = r.value);
n.addEventListener('input', () => { let v = Math.min(99, Math.max(80, parseInt(n.value)||95)); r.value = v; n.value = v; });

// ── ログ ─────────────────────────────────────────────
function log(msg, cls='') {
  const box = document.getElementById('logBox');
  const s = document.createElement('span');
  if (cls) s.className = cls;
  s.innerHTML = msg + '<br>';
  box.appendChild(s);
  box.scrollTop = box.scrollHeight;
}
function clearLog() { document.getElementById('logBox').innerHTML = ''; }

// ── タブ切替 ──────────────────────────────────────────
function switchDs(t) {
  dataSource = t;
  ['yf','csv','syn'].forEach(k => {
    document.getElementById('dsTab'+k.charAt(0).toUpperCase()+k.slice(1)).classList.toggle('active', k===t);
    document.getElementById('dsPanel'+k.charAt(0).toUpperCase()+k.slice(1)).classList.toggle('active', k===t);
  });
}

function switchMode(m) {
  currentMode = m;
  document.getElementById('modeTabLstm').className = 'mode-tab' + (m==='lstm' ? ' active-lstm' : '');
  document.getElementById('modeTabAe').className   = 'mode-tab' + (m==='ae'   ? ' active-ae'   : '');
  document.getElementById('modePanelLstm').classList.toggle('active', m==='lstm');
  document.getElementById('modePanelAe').classList.toggle('active',   m==='ae');
}

// ── プロキシ定義 ──────────────────────────────────────
function buildProxies(symbol, range) {
  // 自サーバープロキシ（最優先・CORS問題なし）
  const selfProxy = 'https://www.iseeit.jp/tools/yf-proxy.php'
    + `?symbol=${encodeURIComponent(symbol)}&range=${encodeURIComponent(range)}`;
  // 外部プロキシ（フォールバック）
  const yfUrl = `https://query1.finance.yahoo.com/v8/finance/chart/${encodeURIComponent(symbol)}`
    + `?interval=1d&range=${range}&events=history`;
  const enc = encodeURIComponent(yfUrl);
  return [
    { name:'iseeit.jp proxy', url: selfProxy,                                                    parse: r=>r.json() },
    { name:'corsproxy.io',    url:`https://corsproxy.io/?${enc}`,                               parse: r=>r.json() },
    { name:'allorigins.win',  url:`https://allorigins.win/get?disableCache=true&url=${enc}`,    parse: async r=>{ const d=await r.json(); return JSON.parse(d.contents); } },
  ];
}
function setPBadge(i, s) { const b=document.getElementById('pb'+i); if(b){ b.className='pbadge '+s; } }

// ── Yahoo Finance 取得 ────────────────────────────────
async function fetchYahoo() {
  const sym   = document.getElementById('yfSymbol').value;
  const range = document.getElementById('yfRange').value;
  clearLog();
  resetResults();
  rawData = []; closeData = [];
  [0,1,2].forEach(i => setPBadge(i,''));

  const btn = document.getElementById('fetchBtn');
  btn.disabled = true; btn.textContent = '取得中...';

  log(`<span class="info">[FETCH]</span> ${sym} (${range})`);

  const proxies = buildProxies(sym, range);
  let ok = false;

  for (let i=0; i<proxies.length; i++) {
    setPBadge(i,'try');
    log(`<span class="info">[TRY]</span> ${proxies[i].name}`);
    try {
      const res = await Promise.race([
        fetch(proxies[i].url),
        new Promise((_,rej) => setTimeout(()=>rej(new Error('timeout')), 8000))
      ]);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const json = await proxies[i].parse(res);
      const result = json?.chart?.result?.[0];
      if (!result) throw new Error('データなし');
      const ts = result.timestamp;
      const q  = result.indicators?.quote?.[0];
      if (!ts||!q) throw new Error('quotes なし');
      rawData = ts.map((t,idx) => ({
        date:  new Date(t*1000).toISOString().split('T')[0],
        close: q.close?.[idx] ?? null,
      })).filter(d => d.close !== null);
      closeData = rawData.map(d => d.close);
      setPBadge(i,'ok');
      for(let j=i+1;j<3;j++) document.getElementById('pb'+j).className='pbadge';
      log(`<span class="ok">[OK]</span> ${rawData.length} 件取得`);
      ok = true; break;
    } catch(e) {
      log(`<span class="warn">[FAIL]</span> ${proxies[i].name}: ${e.message}`);
      setPBadge(i,'fail');
    }
  }

  btn.disabled = false; btn.textContent = '▶ データ取得';

  if (!ok) {
    log('<span class="err">[ERROR]</span> すべてのプロキシで失敗。合成データへ切替えます...');
    generateSyntheticInternal(365, 8);
    switchDs('syn');
    return;
  }
  showFileInfo(sym, 'Yahoo Finance');
  enableRunButtons();
}

// ── CSV 読み込み ──────────────────────────────────────
document.getElementById('csvFile').addEventListener('change', function(e) {
  const file = e.target.files[0]; if (!file) return;
  const reader = new FileReader();
  reader.onload = ev => parseCsv(ev.target.result, file.name);
  reader.readAsText(file, 'UTF-8');
});
const zone = document.getElementById('uploadZone');
zone.addEventListener('dragover', e=>{ e.preventDefault(); zone.classList.add('drag'); });
zone.addEventListener('dragleave', ()=>zone.classList.remove('drag'));
zone.addEventListener('drop', e=>{ e.preventDefault(); zone.classList.remove('drag'); const f=e.dataTransfer.files[0]; if(!f) return; const r=new FileReader(); r.onload=ev=>parseCsv(ev.target.result,f.name); r.readAsText(f,'UTF-8'); });

function parseCsv(text, name) {
  clearLog();
  resetResults();
  const lines = text.trim().split('\n').filter(l => l.trim());
  rawData = [];
  lines.forEach(line => {
    const cols = line.replace(/"/g,'').split(',');
    const date  = cols[0]?.trim();
    const close = parseFloat(cols[1]);
    if (date && date.match(/\d{4}/) && !isNaN(close)) rawData.push({date, close});
  });
  // 昇順に統一
  const toTs = s => new Date(s.replace(/\//g,'-')).getTime();
  const isDesc = rawData.length>=2 && toTs(rawData[0].date) > toTs(rawData[rawData.length-1].date);
  if (isDesc) rawData.reverse();
  closeData = rawData.map(d => d.close);
  if (closeData.length < 50) { log('<span class="err">[ERROR]</span> データが少なすぎます（50件以上必要）'); return; }
  log(`<span class="ok">[OK]</span> ${name}: ${rawData.length} 件`);
  showFileInfo(name, 'CSV');
  enableRunButtons();
}

// ── 合成データ生成 ────────────────────────────────────
function generateSynthetic() {
  const n    = parseInt(document.getElementById('synPoints').value);
  const rate = parseInt(document.getElementById('synAnom').value);
  generateSyntheticInternal(n, rate);
}

function generateSyntheticInternal(n, anomRate) {
  clearLog();
  resetResults();
  rawData = []; closeData = [];
  let price = 145.0;
  const start = new Date('2024-01-04');
  let dc = 0;
  while (rawData.length < n) {
    const d = new Date(start); d.setDate(start.getDate() + dc++);
    if (d.getDay()===0||d.getDay()===6) continue;
    const isAnom = Math.random() < anomRate/100;
    const move   = isAnom
      ? (Math.random()-0.5)*6
      : (Math.random()-0.49)*0.8 + 0.01;
    price = Math.max(100, price + move);
    const yy=d.getFullYear(), mm=String(d.getMonth()+1).padStart(2,'0'), dd=String(d.getDate()).padStart(2,'0');
    rawData.push({ date:`${yy}/${mm}/${dd}`, close:+price.toFixed(3) });
  }
  closeData = rawData.map(d => d.close);
  log(`<span class="ok">[OK]</span> 合成データ生成: ${rawData.length} 件（アノマリー率 ${anomRate}%）`);
  showFileInfo('USD/JPY 合成', '合成データ');
  enableRunButtons();
}

// データ新規読み込み時に結果パネルをすべてリセット
function resetResults() {
  lstmResult = null;
  aeResult   = null;
  document.getElementById('lstmResults').style.display     = 'none';
  document.getElementById('aeResults').style.display       = 'none';
  document.getElementById('combinedResults').style.display = 'none';
  [chartMain, chartLoss, chartAe, chartError, chartCombined].forEach(c => { if(c) c.destroy(); });
  chartMain = chartLoss = chartAe = chartError = chartCombined = null;
}

function showFileInfo(name, source) {
  const fi = document.getElementById('fileInfo');
  fi.classList.add('visible');
  document.getElementById('fi_count').textContent  = rawData.length;
  document.getElementById('fi_period').textContent = `${rawData[0]?.date} 〜 ${rawData[rawData.length-1]?.date}`;
  document.getElementById('fi_latest').textContent = closeData[closeData.length-1]?.toFixed(3) ?? '—';
  document.getElementById('fi_source').textContent = source;
}

function enableRunButtons() {
  document.getElementById('runLstmBtn').disabled = false;
  document.getElementById('runAeBtn').disabled   = false;
}

// ── 正規化 ───────────────────────────────────────────
function normalize(arr) {
  const mn=Math.min(...arr), mx=Math.max(...arr), rng=mx-mn||1;
  return { norm:arr.map(v=>(v-mn)/rng), min:mn, max:mx, range:rng };
}
function denorm(v, min, range) { return v*range+min; }

function makeSequences(normed, win) {
  const X=[], Y=[];
  for(let i=win;i<normed.length;i++){
    X.push(normed.slice(i-win,i).map(v=>[v]));
    Y.push(normed[i]);
  }
  return {X,Y};
}

// ── LSTM 学習・予測 ───────────────────────────────────
async function runLstm() {
  if (closeData.length < 50) { log('<span class="err">[ERROR]</span> データを先に読み込んでください'); return; }
  clearLog();
  document.getElementById('lstmResults').style.display='none';

  const win        = parseInt(document.getElementById('lstmWin').value);
  const steps      = parseInt(document.getElementById('lstmSteps').value);
  const trainRatio = parseInt(document.getElementById('lstmTrainRatio').value)/100;
  const epochs     = 30;
  const batchSize  = 16;

  const btn = document.getElementById('runLstmBtn');
  btn.disabled=true;

  document.getElementById('fetchBtn').disabled = true;
  document.getElementById('runBtnAe').disabled = true;
  document.getElementById('runAeBtn').disabled = true;

  log(`<span class="info">[LSTM]</span> win=${win} steps=${steps} trainRatio=${trainRatio*100}%`);

  const { norm, min:pMin, range:pRange } = normalize(closeData);
  const { X, Y } = makeSequences(norm, win);
  const trainSize = Math.floor(X.length * trainRatio);

  const xTrain = tf.tensor3d(X.slice(0, trainSize));
  const yTrain = tf.tensor2d(Y.slice(0, trainSize), [trainSize, 1]);
  const xTest  = tf.tensor3d(X.slice(trainSize));

  // モデル構築
  const model = tf.sequential();
  model.add(tf.layers.lstm({ units:48, returnSequences:true, inputShape:[win,1] }));
  model.add(tf.layers.dropout({ rate:0.2 }));
  model.add(tf.layers.lstm({ units:24, returnSequences:false }));
  model.add(tf.layers.dropout({ rate:0.2 }));
  model.add(tf.layers.dense({ units:1 }));
  model.compile({ optimizer:tf.train.adam(0.001), loss:'meanSquaredError' });

  // プログレスバー
  const pw = document.getElementById('progressWrap');
  const pb = document.getElementById('progressBar');
  pw.style.display='block'; pb.style.width='0%';

  const lossHist = [];
  let bestLoss = Infinity;

  await model.fit(xTrain, yTrain, {
    epochs, batchSize,
    callbacks: {
      onEpochEnd: async (epoch, logs) => {
        const pct = Math.round((epoch+1)/epochs*100);
        pb.style.width = pct+'%';
        lossHist.push(logs.loss);
        if (logs.loss < bestLoss) bestLoss = logs.loss;
        if ((epoch+1)%5===0||epoch===0) log(`<span class="ok">[E${String(epoch+1).padStart(2,'0')}]</span> loss: ${logs.loss.toFixed(6)}`);
        await tf.nextFrame();
      }
    }
  });

  log('<span class="ok">[DONE]</span> 学習完了');

  // テスト予測
  const yPredNorm   = Array.from(model.predict(xTest).dataSync());
  const yTestActual = Y.slice(trainSize).map(v => denorm(v, pMin, pRange));
  const yPredActual = yPredNorm.map(v => denorm(v, pMin, pRange));

  // RMSE・MAPE
  const rmse = Math.sqrt(yPredActual.reduce((s,v,i) => s+(v-yTestActual[i])**2, 0)/yPredActual.length);
  const mape = yPredActual.reduce((s,v,i) => s+Math.abs((v-yTestActual[i])/(yTestActual[i]||1)), 0)/yPredActual.length*100;

  // 複数ステップ予測
  let seq = norm.slice(norm.length-win).map(v=>[v]);
  const futPred = [];
  for (let s=0; s<steps; s++) {
    const t  = tf.tensor3d([seq]);
    const pv = model.predict(t).dataSync()[0];
    futPred.push(denorm(pv, pMin, pRange));
    seq = [...seq.slice(1), [pv]];
    t.dispose();
  }

  log(`<span class="ok">[RESULT]</span> RMSE: ${rmse.toFixed(3)}  MAPE: ${mape.toFixed(2)}%`);
  log(`<span class="ok">[PRED]</span>  次の値予測: ${futPred[0].toFixed(3)}`);

  // ── 表示 ─────────────────────────────────────────
  document.getElementById('predBox').style.display='block';
  document.getElementById('predVal').textContent = futPred[0].toFixed(3);
  document.getElementById('predSub').textContent = `${steps}ステップ先の最終予測：${futPred[futPred.length-1].toFixed(3)}`;

  const sg = document.getElementById('lstmStats');
  sg.style.display='grid';
  document.getElementById('s_loss').textContent = bestLoss.toFixed(6);
  document.getElementById('s_rmse').textContent = rmse.toFixed(3);
  document.getElementById('s_mape').textContent = mape.toFixed(2)+'%';

  // メインチャート
  const testStartIdx = win + trainSize;
  const testLabels   = rawData.slice(testStartIdx, testStartIdx+yTestActual.length).map(d=>d.date);
  const futLabels    = Array.from({length:steps}, (_,i)=>`+${i+1}`);
  const allLabels    = [...testLabels, ...futLabels];
  const actualPad    = [...yTestActual, ...Array(steps).fill(null)];
  const predPad      = [...yPredActual, ...Array(steps).fill(null)];
  const futPad       = [...Array(yTestActual.length-1).fill(null), yTestActual[yTestActual.length-1], ...futPred];

  const chartDefs = {
    responsive:true, maintainAspectRatio:false,
    plugins:{ legend:{ position:'bottom', labels:{ color:'#4a5a72', font:{size:11}, boxWidth:20 } } },
    scales:{
      x:{ ticks:{ color:'#4a5a72', font:{size:10}, maxTicksLimit:10 }, grid:{ color:'#f0f2f5' } },
      y:{ ticks:{ color:'#4a5a72', font:{size:10} }, grid:{ color:'#f0f2f5' } }
    }
  };

  if (chartMain) chartMain.destroy();
  chartMain = new Chart(document.getElementById('chartMain'), {
    type:'line',
    data:{
      labels: allLabels,
      datasets:[
        { label:'実測値', data:actualPad, borderColor:'#8fa8cc', borderWidth:1.5, pointRadius:0, tension:0.2 },
        { label:'LSTM予測（テスト）', data:predPad, borderColor:'#00d4ff', borderWidth:1.5, borderDash:[4,3], pointRadius:0, tension:0.2 },
        { label:`将来予測（${steps}ステップ）`, data:futPad, borderColor:'#39ff14', borderWidth:2, pointRadius:4, pointBackgroundColor:'#39ff14', tension:0.2, spanGaps:false },
      ]
    },
    options: chartDefs
  });

  if (chartLoss) chartLoss.destroy();
  chartLoss = new Chart(document.getElementById('chartLoss'), {
    type:'line',
    data:{
      labels: Array.from({length:lossHist.length}, (_,i)=>`E${i+1}`),
      datasets:[{ label:'学習曲線（Loss）', data:lossHist, borderColor:'#ff6b35', borderWidth:1.5, pointRadius:0, tension:0.3 }]
    },
    options:{ ...chartDefs, plugins:{ legend:{ labels:{ color:'#4a5a72', font:{size:11} } } } }
  });

  // LSTM結果を保存（統合ビュー用）
  lstmResult = { allLabels, actualPad, predPad, futPad };

  document.getElementById('lstmResults').style.display='block';
  pw.style.display='none';
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      if (chartMain) chartMain.resize();
      if (chartLoss) chartLoss.resize();
      tryRenderCombined();
    });
  });

  xTrain.dispose(); yTrain.dispose(); xTest.dispose(); model.dispose();
  btn.disabled=false;
  
  document.getElementById('fetchBtn').disabled = false;
  document.getElementById('runBtnAe').disabled = false;
  document.getElementById('runAeBtn').disabled = false;
}

// ── AutoEncoder 学習・検出 ────────────────────────────
async function runAe() {
  if (closeData.length < 50) { log('<span class="err">[ERROR]</span> データを先に読み込んでください'); return; }
  clearLog();
  document.getElementById('aeResults').style.display='none';

  const win      = parseInt(document.getElementById('aeWin').value);
  const epochs   = parseInt(document.getElementById('aeEpochs').value);
  const threshPct= parseInt(document.getElementById('n_thresh').value);
  const batch    = 32;

  const btn = document.getElementById('runAeBtn');
  btn.disabled=true;
  
  document.getElementById('fetchBtn').disabled = true;
  document.getElementById('runBtnAe').disabled = true;
  document.getElementById('runLstmBtn').disabled = true;

  log(`<span class="info">[AE]</span> win=${win} epochs=${epochs} thresh=${threshPct}%tile`);

  const { norm } = normalize(closeData);

  // スライディングウィンドウ
  const windows = [];
  for (let i=win; i<norm.length; i++) windows.push(norm.slice(i-win,i));

  const xAll   = tf.tensor2d(windows);
  const xTrain = tf.tensor2d(windows.slice(0, Math.floor(windows.length*0.8)));

  // AutoEncoder 構築
  const model = tf.sequential();
  model.add(tf.layers.dense({ inputShape:[win], units:Math.max(4,Math.floor(win/2)), activation:'relu' }));
  model.add(tf.layers.dense({ units:4, activation:'relu' }));
  model.add(tf.layers.dense({ units:Math.max(4,Math.floor(win/2)), activation:'relu' }));
  model.add(tf.layers.dense({ units:win, activation:'sigmoid' }));
  model.compile({ optimizer:'adam', loss:'meanSquaredError' });

  const pw = document.getElementById('progressWrap');
  const pb = document.getElementById('progressBar');
  pw.style.display='block'; pb.style.width='0%';

  await model.fit(xTrain, xTrain, {
    epochs, batchSize:batch,
    callbacks:{
      onEpochEnd: async (epoch, logs) => {
        pb.style.width = Math.round((epoch+1)/epochs*100)+'%';
        if ((epoch+1)%10===0||epoch===0) log(`<span class="ok">[E${String(epoch+1).padStart(2,'0')}]</span> loss: ${logs.loss.toFixed(6)}`);
        await tf.nextFrame();
      }
    }
  });

  log('<span class="ok">[DONE]</span> 学習完了');

  // 再構成誤差
  const reconArr  = Array.from(model.predict(xAll).dataSync());
  const inputArr  = Array.from(xAll.dataSync());
  const errors    = [];
  for (let i=0; i<windows.length; i++) {
    let mse=0;
    for (let j=0; j<win; j++) mse += (inputArr[i*win+j] - reconArr[i*win+j])**2;
    errors.push(mse/win);
  }

  // 閾値（パーセンタイル）
  const sorted   = [...errors].sort((a,b)=>a-b);
  const tIdx     = Math.floor(sorted.length * threshPct/100);
  const threshold= sorted[tIdx] ?? sorted[sorted.length-1];
  const anomalies= errors.map(e => e > threshold);
  const anomCount= anomalies.filter(Boolean).length;
  const anomRate = (anomCount/errors.length*100).toFixed(1);

  log(`<span class="ok">[RESULT]</span> 閾値: ${threshold.toFixed(6)}  アノマリー: ${anomCount}件（${anomRate}%）`);

  // ── 表示 ─────────────────────────────────────────
  document.getElementById('anomBox').style.display='block';
  document.getElementById('anomVal').textContent = anomCount + ' 件';
  document.getElementById('anomSub').textContent = `全 ${errors.length} 点中 ${anomRate}% がアノマリー`;

  const as = document.getElementById('aeStats');
  as.style.display='grid';
  document.getElementById('ae_total').textContent = errors.length;
  document.getElementById('ae_anom').textContent  = anomCount;
  document.getElementById('ae_rate').textContent  = anomRate+'%';

  // ラベル（ウィンドウの終端日）
  const aeLabels = rawData.slice(win, win+errors.length).map(d=>d.date);
  const closeSlice = closeData.slice(win, win+errors.length);

  // アノマリー点
  const anomPoints = closeSlice.map((v,i) => anomalies[i] ? v : null);

  if (chartAe) chartAe.destroy();
  chartAe = new Chart(document.getElementById('chartAe'), {
    type:'line',
    data:{
      labels: aeLabels,
      datasets:[
        { label:'レート', data:closeSlice, borderColor:'#8fa8cc', borderWidth:1.5, pointRadius:0, tension:0.2 },
        { label:'アノマリー検出点', data:anomPoints, type:'scatter', pointBackgroundColor:'rgba(255,68,68,0.85)', pointRadius:6, pointStyle:'triangle', showLine:false },
      ]
    },
    options:{
      responsive:true, maintainAspectRatio:false,
      plugins:{ legend:{ position:'bottom', labels:{ color:'#4a5a72', font:{size:11}, boxWidth:20 } } },
      scales:{
        x:{ ticks:{ color:'#4a5a72', font:{size:10}, maxTicksLimit:10 }, grid:{ color:'#f0f2f5' } },
        y:{ ticks:{ color:'#4a5a72', font:{size:10} }, grid:{ color:'#f0f2f5' } }
      }
    }
  });

  if (chartError) chartError.destroy();
  chartError = new Chart(document.getElementById('chartError'), {
    type:'line',
    data:{
      labels: aeLabels,
      datasets:[
        { label:'再構成誤差', data:errors, borderColor:'#ff6b35', borderWidth:1, pointRadius:0, tension:0.2, fill:{ target:'origin', above:'rgba(255,107,53,0.08)' } },
        { label:'閾値', data:Array(errors.length).fill(threshold), borderColor:'#ff4444', borderWidth:1.5, borderDash:[6,4], pointRadius:0 },
      ]
    },
    options:{
      responsive:true, maintainAspectRatio:false,
      plugins:{ legend:{ position:'bottom', labels:{ color:'#4a5a72', font:{size:11}, boxWidth:20 } } },
      scales:{
        x:{ ticks:{ color:'#4a5a72', font:{size:10}, maxTicksLimit:10 }, grid:{ color:'#f0f2f5' } },
        y:{ ticks:{ color:'#4a5a72', font:{size:10} }, grid:{ color:'#f0f2f5' } }
      }
    }
  });

  // AE結果を保存（統合ビュー用）
  aeResult = { aeLabels, closeSlice, anomPoints };

  document.getElementById('aeResults').style.display='block';
  pw.style.display='none';
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      if (chartAe)    chartAe.resize();
      if (chartError) chartError.resize();
      tryRenderCombined();
    });
  });

  xAll.dispose(); xTrain.dispose(); model.dispose();
  btn.disabled=false;
  
  document.getElementById('fetchBtn').disabled = false;
  document.getElementById('runBtnAe').disabled = false;
  document.getElementById('runLstmBtn').disabled = false;
}

// ── 統合ビュー描画 ────────────────────────────────────
function tryRenderCombined() {
  if (!lstmResult || !aeResult) return;  // 両方揃っていなければ何もしない

  const { allLabels, actualPad, predPad, futPad } = lstmResult;
  const { aeLabels, closeSlice, anomPoints }        = aeResult;

  // LSTMのラベルとAEのラベルを統合（union）して時系列順に並べる
  // 共通ラベルセットを作り、AEアノマリー点をLSTMラベル空間にマッピング
  // 簡易実装：aeLabelsのアノマリー点をallLabelsに対応付ける
  const anomSet = new Set();
  aeLabels.forEach((label, i) => { if (anomPoints[i] !== null) anomSet.add(label); });

  // LSTM allLabels 空間でアノマリーポイントを構築
  const combinedAnom = allLabels.map((label, i) => {
    if (!anomSet.has(label)) return null;
    // 実測値またはpredPadの値を使用
    return actualPad[i] ?? predPad[i] ?? null;
  });

  if (chartCombined) chartCombined.destroy();
  chartCombined = new Chart(document.getElementById('chartCombined'), {
    type: 'line',
    data: {
      labels: allLabels,
      datasets: [
        {
          label: '実測値',
          data: actualPad,
          borderColor: '#8fa8cc',
          borderWidth: 1.5,
          pointRadius: 0,
          tension: 0.2,
        },
        {
          label: 'LSTM 予測',
          data: predPad,
          borderColor: '#00d4ff',
          borderWidth: 1.5,
          borderDash: [4, 3],
          pointRadius: 0,
          tension: 0.2,
        },
        {
          label: '将来予測',
          data: futPad,
          borderColor: '#39ff14',
          borderWidth: 2,
          pointRadius: 3,
          pointBackgroundColor: '#39ff14',
          tension: 0.2,
          spanGaps: false,
        },
        {
          label: 'アノマリー検出点',
          data: combinedAnom,
          type: 'scatter',
          pointBackgroundColor: 'rgba(255,68,68,0.85)',
          pointRadius: 7,
          pointStyle: 'triangle',
          showLine: false,
        },
      ]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'bottom',
          labels: { color: '#4a5a72', font: { size: 11 }, boxWidth: 20 }
        },
        tooltip: {
          callbacks: {
            label: ctx => ` ${ctx.dataset.label}: ${ctx.parsed.y?.toFixed(3) ?? ''}`
          }
        }
      },
      scales: {
        x: { ticks: { color: '#4a5a72', font: { size: 10 }, maxTicksLimit: 10 }, grid: { color: '#f0f2f5' } },
        y: { ticks: { color: '#4a5a72', font: { size: 10 } }, grid: { color: '#f0f2f5' } }
      }
    }
  });

  document.getElementById('combinedResults').style.display = 'block';
  // スマホ対策resize
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      if (chartCombined) chartCombined.resize();
    });
  });

  log('<span class="ok">[COMBINED]</span> 統合ビューを更新しました');
}

document.getElementById("dsTabYf").addEventListener("click", () => {
  switchDs('yf');
});
document.getElementById("dsTabCsv").addEventListener("click", () => {
  switchDs('csv');
});
document.getElementById("dsTabSyn").addEventListener("click", () => {
  switchDs('syn');
});
document.getElementById("fetchBtn").
addEventListener("click", fetchYahoo);
document.getElementById("runBtnAe").
addEventListener("click", generateSynthetic);
document.getElementById("modeTabLstm").addEventListener("click", () => {
  switchMode('lstm');
});
document.getElementById("modeTabAe").addEventListener("click", () => {
  switchMode('ae');
});
document.getElementById("runLstmBtn").addEventListener("click", runLstm);
document.getElementById("runAeBtn").addEventListener("click", runAe);
